import { createIcon } from './factory'
import Icon from './magnifying-glass.svg?react'

export const MagnifyingGlass = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
